import request from "@/untils/request.js"

export const getFinancialSummaryAccountPage = (params) => {
    return request.get("/outpatient/sostype/page", {params})
}

export const addFinancialSummaryAccount = (data) => {
    return request.post("/outpatient/sostype", data)
}

export const editFinancialSummaryAccount = (data) => {
    return request.put("/outpatient/sostype", data)
}

export const getOneFinancialSummaryAccountById = (id) => {
    return request.get(`/outpatient/sostype/${id}`)
}

//财务汇总科目-列表
export const getFinancialSummaryAccountList = (params) => {
    return request.get('/outpatient/sostype/list',{params})
}